/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  GetLeaderboardByIdOrSlugResponse,
  GetLeaderboardCompetitionsRecentlyCompletedResponse,
  GetLeaderboardCompetitionsResponse,
  JoinLeaderboardBody,
  JoinLeaderboardDeniedResponse,
  JoinLeaderboardResponse,
  LeaderboardCompetitionStatus,
  LeaderboardCompetitionsMyRanksBody,
  LeaderboardCompetitionsMyRanksResponse,
  LeaderboardHistoryResponse,
  LeaderboardMyRankResponse,
  LeaderboardPrizePoolStatus,
  LeaderboardStandingsResponse,
  LeaveLeaderboardBody,
  LeaveLeaderboardDeniedResponse,
  LeaveLeaderboardResponse,
  MyRewardsResponse,
  ScoringHealthResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GetLeaderboardByIdOrSlugResponseFromJSON,
    GetLeaderboardByIdOrSlugResponseToJSON,
    GetLeaderboardCompetitionsRecentlyCompletedResponseFromJSON,
    GetLeaderboardCompetitionsRecentlyCompletedResponseToJSON,
    GetLeaderboardCompetitionsResponseFromJSON,
    GetLeaderboardCompetitionsResponseToJSON,
    JoinLeaderboardBodyFromJSON,
    JoinLeaderboardBodyToJSON,
    JoinLeaderboardDeniedResponseFromJSON,
    JoinLeaderboardDeniedResponseToJSON,
    JoinLeaderboardResponseFromJSON,
    JoinLeaderboardResponseToJSON,
    LeaderboardCompetitionStatusFromJSON,
    LeaderboardCompetitionStatusToJSON,
    LeaderboardCompetitionsMyRanksBodyFromJSON,
    LeaderboardCompetitionsMyRanksBodyToJSON,
    LeaderboardCompetitionsMyRanksResponseFromJSON,
    LeaderboardCompetitionsMyRanksResponseToJSON,
    LeaderboardHistoryResponseFromJSON,
    LeaderboardHistoryResponseToJSON,
    LeaderboardMyRankResponseFromJSON,
    LeaderboardMyRankResponseToJSON,
    LeaderboardPrizePoolStatusFromJSON,
    LeaderboardPrizePoolStatusToJSON,
    LeaderboardStandingsResponseFromJSON,
    LeaderboardStandingsResponseToJSON,
    LeaveLeaderboardBodyFromJSON,
    LeaveLeaderboardBodyToJSON,
    LeaveLeaderboardDeniedResponseFromJSON,
    LeaveLeaderboardDeniedResponseToJSON,
    LeaveLeaderboardResponseFromJSON,
    LeaveLeaderboardResponseToJSON,
    MyRewardsResponseFromJSON,
    MyRewardsResponseToJSON,
    ScoringHealthResponseFromJSON,
    ScoringHealthResponseToJSON,
} from '../models/index';

export interface CreateLeaderboardCompetitionsIdOrSlugJoinRequest {
    idOrSlug: string;
    joinLeaderboardBody?: JoinLeaderboardBody;
}

export interface CreateLeaderboardCompetitionsIdOrSlugLeaveRequest {
    idOrSlug: string;
    leaveLeaderboardBody?: LeaveLeaderboardBody;
}

export interface CreateLeaderboardCompetitionsMyRanksRequest {
    leaderboardCompetitionsMyRanksBody: LeaderboardCompetitionsMyRanksBody;
}

export interface GetLeaderboardCompetitionsRequest {
    gameId?: string;
    status?: Array<LeaderboardCompetitionStatus>;
    limit?: number;
    offset?: number;
}

export interface GetLeaderboardCompetitionsIdHistoryRequest {
    id: string;
    limit?: number;
}

export interface GetLeaderboardCompetitionsIdHistoryPeriodNumberRequest {
    id: string;
    periodNumber: number;
    limit?: number;
    offset?: number;
}

export interface GetLeaderboardCompetitionsIdOrSlugRequest {
    idOrSlug: string;
}

export interface GetLeaderboardCompetitionsIdOrSlugMyRankRequest {
    idOrSlug: string;
}

export interface GetLeaderboardCompetitionsIdOrSlugScoringHealthRequest {
    idOrSlug: string;
}

export interface GetLeaderboardCompetitionsIdOrSlugStandingsRequest {
    idOrSlug: string;
    page?: number;
    pageSize?: number;
}

export interface GetLeaderboardCompetitionsIdPrizePoolRequest {
    id: string;
    periodId?: string;
}

export interface GetLeaderboardCompetitionsMyRewardsRequest {
    limit?: number;
    leaderboardId?: string;
    daysBack?: number;
}

export interface GetLeaderboardCompetitionsRecentlyCompletedRequest {
    gameId?: string;
    daysBack?: number;
    limit?: number;
}

/**
 * LeaderboardCompetitionsApi - interface
 * 
 * @export
 * @interface LeaderboardCompetitionsApiInterface
 */
export interface LeaderboardCompetitionsApiInterface {
    /**
     * Join a leaderboard competition (explicit join)
     * @param {string} idOrSlug 
     * @param {JoinLeaderboardBody} [joinLeaderboardBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    createLeaderboardCompetitionsIdOrSlugJoinRaw(requestParameters: CreateLeaderboardCompetitionsIdOrSlugJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JoinLeaderboardResponse>>;

    /**
     * Join a leaderboard competition (explicit join)
     */
    createLeaderboardCompetitionsIdOrSlugJoin(requestParameters: CreateLeaderboardCompetitionsIdOrSlugJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JoinLeaderboardResponse>;

    /**
     * Cancel an upcoming entry and get the entry fee back. Only an entry for an occurrence that has NOT started can be cancelled; once its period opens the entry is competing and the prize pool belongs to everyone still in it. A token-funded entry has its token restored rather than being paid out as Fuel.
     * @param {string} idOrSlug 
     * @param {LeaveLeaderboardBody} [leaveLeaderboardBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    createLeaderboardCompetitionsIdOrSlugLeaveRaw(requestParameters: CreateLeaderboardCompetitionsIdOrSlugLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaveLeaderboardResponse>>;

    /**
     * Cancel an upcoming entry and get the entry fee back. Only an entry for an occurrence that has NOT started can be cancelled; once its period opens the entry is competing and the prize pool belongs to everyone still in it. A token-funded entry has its token restored rather than being paid out as Fuel.
     */
    createLeaderboardCompetitionsIdOrSlugLeave(requestParameters: CreateLeaderboardCompetitionsIdOrSlugLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaveLeaderboardResponse>;

    /**
     * Batched lookup of the authenticated user\'s rank across multiple leaderboards in a single request.
     * @param {LeaderboardCompetitionsMyRanksBody} leaderboardCompetitionsMyRanksBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    createLeaderboardCompetitionsMyRanksRaw(requestParameters: CreateLeaderboardCompetitionsMyRanksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardCompetitionsMyRanksResponse>>;

    /**
     * Batched lookup of the authenticated user\'s rank across multiple leaderboards in a single request.
     */
    createLeaderboardCompetitionsMyRanks(requestParameters: CreateLeaderboardCompetitionsMyRanksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardCompetitionsMyRanksResponse>;

    /**
     * List leaderboard competitions with optional status filtering
     * @param {string} [gameId] 
     * @param {Array<LeaderboardCompetitionStatus>} [status] Filter by any of these statuses. Repeatable. If omitted, returns ACTIVE + SCHEDULED (live and upcoming).
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsRaw(requestParameters: GetLeaderboardCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaderboardCompetitionsResponse>>;

    /**
     * List leaderboard competitions with optional status filtering
     */
    getLeaderboardCompetitions(requestParameters: GetLeaderboardCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaderboardCompetitionsResponse>;

    /**
     * Get historical period snapshots for a leaderboard
     * @param {string} id 
     * @param {number} [limit] Upper bound on returned periods, capped further by the board\&#39;s cadence so the window is a comparable span rather than a raw count — daily returns at most 5, weekly 4, monthly 2, custom 7, one-time 1. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsIdHistoryRaw(requestParameters: GetLeaderboardCompetitionsIdHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardHistoryResponse>>;

    /**
     * Get historical period snapshots for a leaderboard
     */
    getLeaderboardCompetitionsIdHistory(requestParameters: GetLeaderboardCompetitionsIdHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardHistoryResponse>;

    /**
     * Get full standings for a specific completed period
     * @param {string} id 
     * @param {number} periodNumber 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsIdHistoryPeriodNumberRaw(requestParameters: GetLeaderboardCompetitionsIdHistoryPeriodNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get full standings for a specific completed period
     */
    getLeaderboardCompetitionsIdHistoryPeriodNumber(requestParameters: GetLeaderboardCompetitionsIdHistoryPeriodNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Get a leaderboard competition by ID or slug
     * @param {string} idOrSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsIdOrSlugRaw(requestParameters: GetLeaderboardCompetitionsIdOrSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaderboardByIdOrSlugResponse>>;

    /**
     * Get a leaderboard competition by ID or slug
     */
    getLeaderboardCompetitionsIdOrSlug(requestParameters: GetLeaderboardCompetitionsIdOrSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaderboardByIdOrSlugResponse>;

    /**
     * Get authenticated user\'s rank in a leaderboard
     * @param {string} idOrSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsIdOrSlugMyRankRaw(requestParameters: GetLeaderboardCompetitionsIdOrSlugMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardMyRankResponse>>;

    /**
     * Get authenticated user\'s rank in a leaderboard
     */
    getLeaderboardCompetitionsIdOrSlugMyRank(requestParameters: GetLeaderboardCompetitionsIdOrSlugMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardMyRankResponse>;

    /**
     * Whether the calling player\'s play is counting on this board — the client they are playing through and the mode they are in. Registered players only.
     * @param {string} idOrSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsIdOrSlugScoringHealthRaw(requestParameters: GetLeaderboardCompetitionsIdOrSlugScoringHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScoringHealthResponse>>;

    /**
     * Whether the calling player\'s play is counting on this board — the client they are playing through and the mode they are in. Registered players only.
     */
    getLeaderboardCompetitionsIdOrSlugScoringHealth(requestParameters: GetLeaderboardCompetitionsIdOrSlugScoringHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScoringHealthResponse>;

    /**
     * Get leaderboard standings with pagination. A board that is over falls back to its most recent snapshot. Between occurrences standings are empty and registrants lists the next occurrence; past results are in history.
     * @param {string} idOrSlug 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsIdOrSlugStandingsRaw(requestParameters: GetLeaderboardCompetitionsIdOrSlugStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardStandingsResponse>>;

    /**
     * Get leaderboard standings with pagination. A board that is over falls back to its most recent snapshot. Between occurrences standings are empty and registrants lists the next occurrence; past results are in history.
     */
    getLeaderboardCompetitionsIdOrSlugStandings(requestParameters: GetLeaderboardCompetitionsIdOrSlugStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardStandingsResponse>;

    /**
     * Get current prize pool status for a leaderboard with entry fees. Use this for real-time prize pool displays.
     * @param {string} id 
     * @param {string} [periodId] Optional period ID for recurring leaderboards with PER_PERIOD entry mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsIdPrizePoolRaw(requestParameters: GetLeaderboardCompetitionsIdPrizePoolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardPrizePoolStatus>>;

    /**
     * Get current prize pool status for a leaderboard with entry fees. Use this for real-time prize pool displays.
     */
    getLeaderboardCompetitionsIdPrizePool(requestParameters: GetLeaderboardCompetitionsIdPrizePoolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardPrizePoolStatus>;

    /**
     * Get authenticated user\'s prizes from completed leaderboard periods
     * @param {number} [limit] 
     * @param {string} [leaderboardId] Filter to specific leaderboard (for recurring leaderboards showing past periods)
     * @param {number} [daysBack] How many days of history to include. Default 7, capped at 365. Pass 0 to disable the filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsMyRewardsRaw(requestParameters: GetLeaderboardCompetitionsMyRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyRewardsResponse>>;

    /**
     * Get authenticated user\'s prizes from completed leaderboard periods
     */
    getLeaderboardCompetitionsMyRewards(requestParameters: GetLeaderboardCompetitionsMyRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyRewardsResponse>;

    /**
     * Get leaderboards that completed within the last N days
     * @param {string} [gameId] 
     * @param {number} [daysBack] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaderboardCompetitionsApiInterface
     */
    getLeaderboardCompetitionsRecentlyCompletedRaw(requestParameters: GetLeaderboardCompetitionsRecentlyCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaderboardCompetitionsRecentlyCompletedResponse>>;

    /**
     * Get leaderboards that completed within the last N days
     */
    getLeaderboardCompetitionsRecentlyCompleted(requestParameters: GetLeaderboardCompetitionsRecentlyCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaderboardCompetitionsRecentlyCompletedResponse>;

}

/**
 * 
 */
export class LeaderboardCompetitionsApi extends runtime.BaseAPI implements LeaderboardCompetitionsApiInterface {

    /**
     * Join a leaderboard competition (explicit join)
     */
    async createLeaderboardCompetitionsIdOrSlugJoinRaw(requestParameters: CreateLeaderboardCompetitionsIdOrSlugJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JoinLeaderboardResponse>> {
        if (requestParameters['idOrSlug'] == null) {
            throw new runtime.RequiredError(
                'idOrSlug',
                'Required parameter "idOrSlug" was null or undefined when calling createLeaderboardCompetitionsIdOrSlugJoin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leaderboard-competitions/{idOrSlug}/join`;
        urlPath = urlPath.replace(`{${"idOrSlug"}}`, encodeURIComponent(String(requestParameters['idOrSlug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JoinLeaderboardBodyToJSON(requestParameters['joinLeaderboardBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JoinLeaderboardResponseFromJSON(jsonValue));
    }

    /**
     * Join a leaderboard competition (explicit join)
     */
    async createLeaderboardCompetitionsIdOrSlugJoin(requestParameters: CreateLeaderboardCompetitionsIdOrSlugJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JoinLeaderboardResponse> {
        const response = await this.createLeaderboardCompetitionsIdOrSlugJoinRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel an upcoming entry and get the entry fee back. Only an entry for an occurrence that has NOT started can be cancelled; once its period opens the entry is competing and the prize pool belongs to everyone still in it. A token-funded entry has its token restored rather than being paid out as Fuel.
     */
    async createLeaderboardCompetitionsIdOrSlugLeaveRaw(requestParameters: CreateLeaderboardCompetitionsIdOrSlugLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaveLeaderboardResponse>> {
        if (requestParameters['idOrSlug'] == null) {
            throw new runtime.RequiredError(
                'idOrSlug',
                'Required parameter "idOrSlug" was null or undefined when calling createLeaderboardCompetitionsIdOrSlugLeave().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leaderboard-competitions/{idOrSlug}/leave`;
        urlPath = urlPath.replace(`{${"idOrSlug"}}`, encodeURIComponent(String(requestParameters['idOrSlug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LeaveLeaderboardBodyToJSON(requestParameters['leaveLeaderboardBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaveLeaderboardResponseFromJSON(jsonValue));
    }

    /**
     * Cancel an upcoming entry and get the entry fee back. Only an entry for an occurrence that has NOT started can be cancelled; once its period opens the entry is competing and the prize pool belongs to everyone still in it. A token-funded entry has its token restored rather than being paid out as Fuel.
     */
    async createLeaderboardCompetitionsIdOrSlugLeave(requestParameters: CreateLeaderboardCompetitionsIdOrSlugLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaveLeaderboardResponse> {
        const response = await this.createLeaderboardCompetitionsIdOrSlugLeaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Batched lookup of the authenticated user\'s rank across multiple leaderboards in a single request.
     */
    async createLeaderboardCompetitionsMyRanksRaw(requestParameters: CreateLeaderboardCompetitionsMyRanksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardCompetitionsMyRanksResponse>> {
        if (requestParameters['leaderboardCompetitionsMyRanksBody'] == null) {
            throw new runtime.RequiredError(
                'leaderboardCompetitionsMyRanksBody',
                'Required parameter "leaderboardCompetitionsMyRanksBody" was null or undefined when calling createLeaderboardCompetitionsMyRanks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leaderboard-competitions/my-ranks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LeaderboardCompetitionsMyRanksBodyToJSON(requestParameters['leaderboardCompetitionsMyRanksBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardCompetitionsMyRanksResponseFromJSON(jsonValue));
    }

    /**
     * Batched lookup of the authenticated user\'s rank across multiple leaderboards in a single request.
     */
    async createLeaderboardCompetitionsMyRanks(requestParameters: CreateLeaderboardCompetitionsMyRanksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardCompetitionsMyRanksResponse> {
        const response = await this.createLeaderboardCompetitionsMyRanksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List leaderboard competitions with optional status filtering
     */
    async getLeaderboardCompetitionsRaw(requestParameters: GetLeaderboardCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaderboardCompetitionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leaderboard-competitions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeaderboardCompetitionsResponseFromJSON(jsonValue));
    }

    /**
     * List leaderboard competitions with optional status filtering
     */
    async getLeaderboardCompetitions(requestParameters: GetLeaderboardCompetitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaderboardCompetitionsResponse> {
        const response = await this.getLeaderboardCompetitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get historical period snapshots for a leaderboard
     */
    async getLeaderboardCompetitionsIdHistoryRaw(requestParameters: GetLeaderboardCompetitionsIdHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardHistoryResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaderboardCompetitionsIdHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leaderboard-competitions/{id}/history`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get historical period snapshots for a leaderboard
     */
    async getLeaderboardCompetitionsIdHistory(requestParameters: GetLeaderboardCompetitionsIdHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardHistoryResponse> {
        const response = await this.getLeaderboardCompetitionsIdHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get full standings for a specific completed period
     */
    async getLeaderboardCompetitionsIdHistoryPeriodNumberRaw(requestParameters: GetLeaderboardCompetitionsIdHistoryPeriodNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaderboardCompetitionsIdHistoryPeriodNumber().'
            );
        }

        if (requestParameters['periodNumber'] == null) {
            throw new runtime.RequiredError(
                'periodNumber',
                'Required parameter "periodNumber" was null or undefined when calling getLeaderboardCompetitionsIdHistoryPeriodNumber().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leaderboard-competitions/{id}/history/{periodNumber}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"periodNumber"}}`, encodeURIComponent(String(requestParameters['periodNumber'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get full standings for a specific completed period
     */
    async getLeaderboardCompetitionsIdHistoryPeriodNumber(requestParameters: GetLeaderboardCompetitionsIdHistoryPeriodNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getLeaderboardCompetitionsIdHistoryPeriodNumberRaw(requestParameters, initOverrides);
    }

    /**
     * Get a leaderboard competition by ID or slug
     */
    async getLeaderboardCompetitionsIdOrSlugRaw(requestParameters: GetLeaderboardCompetitionsIdOrSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaderboardByIdOrSlugResponse>> {
        if (requestParameters['idOrSlug'] == null) {
            throw new runtime.RequiredError(
                'idOrSlug',
                'Required parameter "idOrSlug" was null or undefined when calling getLeaderboardCompetitionsIdOrSlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leaderboard-competitions/{idOrSlug}`;
        urlPath = urlPath.replace(`{${"idOrSlug"}}`, encodeURIComponent(String(requestParameters['idOrSlug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeaderboardByIdOrSlugResponseFromJSON(jsonValue));
    }

    /**
     * Get a leaderboard competition by ID or slug
     */
    async getLeaderboardCompetitionsIdOrSlug(requestParameters: GetLeaderboardCompetitionsIdOrSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaderboardByIdOrSlugResponse> {
        const response = await this.getLeaderboardCompetitionsIdOrSlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get authenticated user\'s rank in a leaderboard
     */
    async getLeaderboardCompetitionsIdOrSlugMyRankRaw(requestParameters: GetLeaderboardCompetitionsIdOrSlugMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardMyRankResponse>> {
        if (requestParameters['idOrSlug'] == null) {
            throw new runtime.RequiredError(
                'idOrSlug',
                'Required parameter "idOrSlug" was null or undefined when calling getLeaderboardCompetitionsIdOrSlugMyRank().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leaderboard-competitions/{idOrSlug}/my-rank`;
        urlPath = urlPath.replace(`{${"idOrSlug"}}`, encodeURIComponent(String(requestParameters['idOrSlug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardMyRankResponseFromJSON(jsonValue));
    }

    /**
     * Get authenticated user\'s rank in a leaderboard
     */
    async getLeaderboardCompetitionsIdOrSlugMyRank(requestParameters: GetLeaderboardCompetitionsIdOrSlugMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardMyRankResponse> {
        const response = await this.getLeaderboardCompetitionsIdOrSlugMyRankRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Whether the calling player\'s play is counting on this board — the client they are playing through and the mode they are in. Registered players only.
     */
    async getLeaderboardCompetitionsIdOrSlugScoringHealthRaw(requestParameters: GetLeaderboardCompetitionsIdOrSlugScoringHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScoringHealthResponse>> {
        if (requestParameters['idOrSlug'] == null) {
            throw new runtime.RequiredError(
                'idOrSlug',
                'Required parameter "idOrSlug" was null or undefined when calling getLeaderboardCompetitionsIdOrSlugScoringHealth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leaderboard-competitions/{idOrSlug}/scoring-health`;
        urlPath = urlPath.replace(`{${"idOrSlug"}}`, encodeURIComponent(String(requestParameters['idOrSlug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScoringHealthResponseFromJSON(jsonValue));
    }

    /**
     * Whether the calling player\'s play is counting on this board — the client they are playing through and the mode they are in. Registered players only.
     */
    async getLeaderboardCompetitionsIdOrSlugScoringHealth(requestParameters: GetLeaderboardCompetitionsIdOrSlugScoringHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScoringHealthResponse> {
        const response = await this.getLeaderboardCompetitionsIdOrSlugScoringHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get leaderboard standings with pagination. A board that is over falls back to its most recent snapshot. Between occurrences standings are empty and registrants lists the next occurrence; past results are in history.
     */
    async getLeaderboardCompetitionsIdOrSlugStandingsRaw(requestParameters: GetLeaderboardCompetitionsIdOrSlugStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardStandingsResponse>> {
        if (requestParameters['idOrSlug'] == null) {
            throw new runtime.RequiredError(
                'idOrSlug',
                'Required parameter "idOrSlug" was null or undefined when calling getLeaderboardCompetitionsIdOrSlugStandings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leaderboard-competitions/{idOrSlug}/standings`;
        urlPath = urlPath.replace(`{${"idOrSlug"}}`, encodeURIComponent(String(requestParameters['idOrSlug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardStandingsResponseFromJSON(jsonValue));
    }

    /**
     * Get leaderboard standings with pagination. A board that is over falls back to its most recent snapshot. Between occurrences standings are empty and registrants lists the next occurrence; past results are in history.
     */
    async getLeaderboardCompetitionsIdOrSlugStandings(requestParameters: GetLeaderboardCompetitionsIdOrSlugStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardStandingsResponse> {
        const response = await this.getLeaderboardCompetitionsIdOrSlugStandingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current prize pool status for a leaderboard with entry fees. Use this for real-time prize pool displays.
     */
    async getLeaderboardCompetitionsIdPrizePoolRaw(requestParameters: GetLeaderboardCompetitionsIdPrizePoolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardPrizePoolStatus>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLeaderboardCompetitionsIdPrizePool().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['periodId'] != null) {
            queryParameters['periodId'] = requestParameters['periodId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leaderboard-competitions/{id}/prize-pool`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardPrizePoolStatusFromJSON(jsonValue));
    }

    /**
     * Get current prize pool status for a leaderboard with entry fees. Use this for real-time prize pool displays.
     */
    async getLeaderboardCompetitionsIdPrizePool(requestParameters: GetLeaderboardCompetitionsIdPrizePoolRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardPrizePoolStatus> {
        const response = await this.getLeaderboardCompetitionsIdPrizePoolRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get authenticated user\'s prizes from completed leaderboard periods
     */
    async getLeaderboardCompetitionsMyRewardsRaw(requestParameters: GetLeaderboardCompetitionsMyRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyRewardsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['leaderboardId'] != null) {
            queryParameters['leaderboardId'] = requestParameters['leaderboardId'];
        }

        if (requestParameters['daysBack'] != null) {
            queryParameters['daysBack'] = requestParameters['daysBack'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/leaderboard-competitions/my-rewards`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyRewardsResponseFromJSON(jsonValue));
    }

    /**
     * Get authenticated user\'s prizes from completed leaderboard periods
     */
    async getLeaderboardCompetitionsMyRewards(requestParameters: GetLeaderboardCompetitionsMyRewardsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyRewardsResponse> {
        const response = await this.getLeaderboardCompetitionsMyRewardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get leaderboards that completed within the last N days
     */
    async getLeaderboardCompetitionsRecentlyCompletedRaw(requestParameters: GetLeaderboardCompetitionsRecentlyCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaderboardCompetitionsRecentlyCompletedResponse>> {
        const queryParameters: any = {};

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['daysBack'] != null) {
            queryParameters['daysBack'] = requestParameters['daysBack'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leaderboard-competitions/recently-completed`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeaderboardCompetitionsRecentlyCompletedResponseFromJSON(jsonValue));
    }

    /**
     * Get leaderboards that completed within the last N days
     */
    async getLeaderboardCompetitionsRecentlyCompleted(requestParameters: GetLeaderboardCompetitionsRecentlyCompletedRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaderboardCompetitionsRecentlyCompletedResponse> {
        const response = await this.getLeaderboardCompetitionsRecentlyCompletedRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
